import _assertThisInitialized from "/var/lib/jenkins/workspace/netstore-ui-frontend-triggered-build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _slicedToArray from "/var/lib/jenkins/workspace/netstore-ui-frontend-triggered-build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _possibleConstructorReturn from "/var/lib/jenkins/workspace/netstore-ui-frontend-triggered-build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/lib/jenkins/workspace/netstore-ui-frontend-triggered-build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/lib/jenkins/workspace/netstore-ui-frontend-triggered-build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/var/lib/jenkins/workspace/netstore-ui-frontend-triggered-build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _classCallCheck from "/var/lib/jenkins/workspace/netstore-ui-frontend-triggered-build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/workspace/netstore-ui-frontend-triggered-build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _toConsumableArray from "/var/lib/jenkins/workspace/netstore-ui-frontend-triggered-build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/var/lib/jenkins/workspace/netstore-ui-frontend-triggered-build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/var/lib/jenkins/workspace/netstore-ui-frontend-triggered-build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var Qe = function Qe(i, f, c) {
  if (!f.has(i)) throw TypeError("Cannot " + c);
};

var se = function se(i, f, c) {
  return Qe(i, f, "read from private field"), c ? c.call(i) : f.get(i);
},
    Ze = function Ze(i, f, c) {
  if (f.has(i)) throw TypeError("Cannot add the same private member more than once");
  f instanceof WeakSet ? f.add(i) : f.set(i, c);
},
    Je = function Je(i, f, c, w) {
  return Qe(i, f, "write to private field"), w ? w.call(i, c) : f.set(i, c), c;
};

var Ke = ["Aztec", "Codabar", "Code128", "Code39", "Code93", "DataBar", "DataBarExpanded", "DataMatrix", "DXFilmEdge", "EAN-13", "EAN-8", "ITF", "Linear-Codes", "Matrix-Codes", "MaxiCode", "MicroQRCode", "None", "PDF417", "QRCode", "rMQRCode", "UPC-A", "UPC-E"];

function Ha(i) {
  return i.join("|");
}

function Ba(i) {
  var f = tr(i);
  var c = 0,
      w = Ke.length - 1;

  for (; c <= w;) {
    var v = Math.floor((c + w) / 2),
        $ = Ke[v],
        B = tr($);
    if (B === f) return $;
    B < f ? c = v + 1 : w = v - 1;
  }

  return "None";
}

function tr(i) {
  return i.toLowerCase().replace(/_-\[\]/g, "");
}

function Ua(i, f) {
  return i.Binarizer[f];
}

function Va(i, f) {
  return i.CharacterSet[f];
}

var La = ["Text", "Binary", "Mixed", "GS1", "ISO15434", "UnknownECI"];

function Ya(i) {
  return La[i.value];
}

function za(i, f) {
  return i.EanAddOnSymbol[f];
}

function Na(i, f) {
  return i.TextMode[f];
}

var dt = {
  formats: [],
  tryHarder: !0,
  tryRotate: !0,
  tryInvert: !0,
  tryDownscale: !0,
  binarizer: "LocalAverage",
  isPure: !1,
  downscaleFactor: 3,
  downscaleThreshold: 500,
  minLineCount: 2,
  maxNumberOfSymbols: 255,
  tryCode39ExtendedMode: !1,
  validateCode39CheckSum: !1,
  validateITFCheckSum: !1,
  returnCodabarStartEnd: !1,
  returnErrors: !1,
  eanAddOnSymbol: "Read",
  textMode: "Plain",
  characterSet: "Unknown"
};

function rr(i, f) {
  return _objectSpread({}, f, {
    formats: Ha(f.formats),
    binarizer: Ua(i, f.binarizer),
    eanAddOnSymbol: za(i, f.eanAddOnSymbol),
    textMode: Na(i, f.textMode),
    characterSet: Va(i, f.characterSet)
  });
}

function nr(i) {
  return _objectSpread({}, i, {
    format: Ba(i.format),
    eccLevel: i.eccLevel,
    contentType: Ya(i.contentType)
  });
}

var Ga = {
  locateFile: function locateFile(i, f) {
    var c = i.match(/_(.+?)\.wasm$/);
    return c ? "https://fastly.jsdelivr.net/npm/zxing-wasm@1.2.4/dist/".concat(c[1], "/").concat(i) : f + i;
  }
};
var ue = /* @__PURE__ */new WeakMap();

function ce(i, f) {
  var c;
  var w = ue.get(i);
  if (w != null && w.modulePromise && (f === void 0 || Object.is(f, w.moduleOverrides))) return w.modulePromise;
  var v = (c = f != null ? f : w == null ? void 0 : w.moduleOverrides) != null ? c : Ga,
      $ = i(_objectSpread({}, v));
  return ue.set(i, {
    moduleOverrides: v,
    modulePromise: $
  }), $;
}

function Xa(i, f) {
  ue.set(i, {
    moduleOverrides: f
  });
}

function qa(_x, _x2) {
  return _qa.apply(this, arguments);
}

function _qa() {
  _qa = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(i, f) {
    var c,
        w,
        v,
        $,
        B,
        U,
        V,
        H,
        M,
        _args3 = arguments;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            c = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : dt;
            w = _objectSpread({}, dt, c);
            _context3.next = 4;
            return ce(i);

          case 4:
            v = _context3.sent;
            $ = f.size;
            _context3.t0 = Uint8Array;
            _context3.next = 9;
            return f.arrayBuffer();

          case 9:
            _context3.t1 = _context3.sent;
            B = new _context3.t0(_context3.t1);
            U = v._malloc($);
            v.HEAPU8.set(B, U);
            V = v.readBarcodesFromImage(U, $, rr(v, w));

            v._free(U);

            H = [];

            for (M = 0; M < V.size(); ++M) {
              H.push(nr(V.get(M)));
            }

            return _context3.abrupt("return", H);

          case 18:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _qa.apply(this, arguments);
}

function Qa(_x3, _x4) {
  return _Qa.apply(this, arguments);
}

function _Qa() {
  _Qa = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(i, f) {
    var c,
        w,
        v,
        $,
        B,
        U,
        V,
        H,
        M,
        K,
        L,
        _args4 = arguments;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            c = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : dt;
            w = _objectSpread({}, dt, c);
            _context4.next = 4;
            return ce(i);

          case 4:
            v = _context4.sent;
            $ = f.data;
            B = f.width;
            U = f.height;
            V = f.data.byteLength;
            H = v._malloc(V);
            v.HEAPU8.set($, H);
            M = v.readBarcodesFromPixmap(H, B, U, rr(v, w));

            v._free(H);

            K = [];

            for (L = 0; L < M.size(); ++L) {
              K.push(nr(M.get(L)));
            }

            return _context4.abrupt("return", K);

          case 16:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _Qa.apply(this, arguments);
}

_objectSpread({}, dt, {
  formats: _toConsumableArray(dt.formats)
});

var Ut = function () {
  var i = typeof document < "u" && document.currentScript ? document.currentScript.src : void 0;
  return function () {
    var f = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var c = f,
        w,
        v;
    c.ready = new Promise(function (e, t) {
      w = e, v = t;
    });
    var $ = Object.assign({}, c),
        B = "./this.program",
        U = typeof window == "object",
        V = typeof Bun < "u",
        H = typeof importScripts == "function";
    typeof process == "object" && typeof process.versions == "object" && process.versions.node;
    var M = "";

    function K(e) {
      return c.locateFile ? c.locateFile(e, M) : M + e;
    }

    var L;
    (U || H || V) && (H ? M = self.location.href : typeof document < "u" && document.currentScript && (M = document.currentScript.src), i && (M = i), M.startsWith("blob:") ? M = "" : M = M.substr(0, M.replace(/[?#].*/, "").lastIndexOf("/") + 1), H && (L = function L(e) {
      var t = new XMLHttpRequest();
      return t.open("GET", e, !1), t.responseType = "arraybuffer", t.send(null), new Uint8Array(t.response);
    }));
    var ht = c.print || console.log.bind(console),
        X = c.printErr || console.error.bind(console);
    Object.assign(c, $), $ = null, c.arguments && c.arguments, c.thisProgram && (B = c.thisProgram), c.quit && c.quit;
    var tt;
    c.wasmBinary && (tt = c.wasmBinary), typeof WebAssembly != "object" && Tt("no native wasm support detected");

    var at,
        _t = !1,
        Y,
        W,
        ot,
        ft,
        R,
        _,
        le,
        de;

    function he() {
      var e = at.buffer;
      c.HEAP8 = Y = new Int8Array(e), c.HEAP16 = ot = new Int16Array(e), c.HEAPU8 = W = new Uint8Array(e), c.HEAPU16 = ft = new Uint16Array(e), c.HEAP32 = R = new Int32Array(e), c.HEAPU32 = _ = new Uint32Array(e), c.HEAPF32 = le = new Float32Array(e), c.HEAPF64 = de = new Float64Array(e);
    }

    var fe = [],
        pe = [],
        me = [];

    function pr() {
      if (c.preRun) for (typeof c.preRun == "function" && (c.preRun = [c.preRun]); c.preRun.length;) {
        vr(c.preRun.shift());
      }
      Vt(fe);
    }

    function mr() {
      Vt(pe);
    }

    function yr() {
      if (c.postRun) for (typeof c.postRun == "function" && (c.postRun = [c.postRun]); c.postRun.length;) {
        wr(c.postRun.shift());
      }
      Vt(me);
    }

    function vr(e) {
      fe.unshift(e);
    }

    function gr(e) {
      pe.unshift(e);
    }

    function wr(e) {
      me.unshift(e);
    }

    var et = 0,
        pt = null;

    function $r(e) {
      var t;
      et++, (t = c.monitorRunDependencies) === null || t === void 0 || t.call(c, et);
    }

    function br(e) {
      var t;

      if (et--, (t = c.monitorRunDependencies) === null || t === void 0 || t.call(c, et), et == 0 && pt) {
        var r = pt;
        pt = null, r();
      }
    }

    function Tt(e) {
      var t;
      (t = c.onAbort) === null || t === void 0 || t.call(c, e), e = "Aborted(" + e + ")", X(e), _t = !0, e += ". Build with -sASSERTIONS for more info.";
      var r = new WebAssembly.RuntimeError(e);
      throw v(r), r;
    }

    var Cr = "data:application/octet-stream;base64,",
        ye = function ye(e) {
      return e.startsWith(Cr);
    },
        it;

    it = "zxing_reader.wasm", ye(it) || (it = K(it));

    function ve(e) {
      if (e == it && tt) return new Uint8Array(tt);
      if (L) return L(e);
      throw "both async and sync fetching of the wasm failed";
    }

    function _r(e) {
      return !tt && (U || H || V) && typeof fetch == "function" ? fetch(e, {
        credentials: "same-origin"
      }).then(function (t) {
        if (!t.ok) throw "failed to load wasm binary file at '".concat(e, "'");
        return t.arrayBuffer();
      }).catch(function () {
        return ve(e);
      }) : Promise.resolve().then(function () {
        return ve(e);
      });
    }

    function ge(e, t, r) {
      return _r(e).then(function (n) {
        return WebAssembly.instantiate(n, t);
      }).then(r, function (n) {
        X("failed to asynchronously prepare wasm: ".concat(n)), Tt(n);
      });
    }

    function Tr(e, t, r, n) {
      return !e && typeof WebAssembly.instantiateStreaming == "function" && !ye(t) && typeof fetch == "function" ? fetch(t, {
        credentials: "same-origin"
      }).then(function (a) {
        var o = WebAssembly.instantiateStreaming(a, r);
        return o.then(n, function (s) {
          return X("wasm streaming compile failed: ".concat(s)), X("falling back to ArrayBuffer instantiation"), ge(t, r, n);
        });
      }) : ge(t, r, n);
    }

    function Pr() {
      var e = {
        a: va
      };

      function t(n, a) {
        return A = n.exports, at = A.ma, he(), Ae = A.qa, gr(A.na), br(), A;
      }

      $r();

      function r(n) {
        t(n.instance);
      }

      if (c.instantiateWasm) try {
        return c.instantiateWasm(e, t);
      } catch (n) {
        X("Module.instantiateWasm callback failed with error: ".concat(n)), v(n);
      }
      return Tr(tt, it, e, r).catch(v), {};
    }

    var Vt = function Vt(e) {
      for (; e.length > 0;) {
        e.shift()(c);
      }
    };

    c.noExitRuntime;

    var Pt = [],
        Et = 0,
        Er = function Er(e) {
      var t = new Lt(e);
      return t.get_caught() || (t.set_caught(!0), Et--), t.set_rethrown(!1), Pt.push(t), _Ve(t.excPtr), t.get_exception_ptr();
    },
        q = 0,
        Ar = function Ar() {
      _T(0, 0);

      var e = Pt.pop();
      _Ue(e.excPtr), q = 0;
    };

    var Lt = /*#__PURE__*/function () {
      function Lt(t) {
        _classCallCheck(this, Lt);

        this.excPtr = t, this.ptr = t - 24;
      }

      _createClass(Lt, [{
        key: "set_type",
        value: function set_type(t) {
          _[this.ptr + 4 >> 2] = t;
        }
      }, {
        key: "get_type",
        value: function get_type() {
          return _[this.ptr + 4 >> 2];
        }
      }, {
        key: "set_destructor",
        value: function set_destructor(t) {
          _[this.ptr + 8 >> 2] = t;
        }
      }, {
        key: "get_destructor",
        value: function get_destructor() {
          return _[this.ptr + 8 >> 2];
        }
      }, {
        key: "set_caught",
        value: function set_caught(t) {
          t = t ? 1 : 0, Y[this.ptr + 12] = t;
        }
      }, {
        key: "get_caught",
        value: function get_caught() {
          return Y[this.ptr + 12] != 0;
        }
      }, {
        key: "set_rethrown",
        value: function set_rethrown(t) {
          t = t ? 1 : 0, Y[this.ptr + 13] = t;
        }
      }, {
        key: "get_rethrown",
        value: function get_rethrown() {
          return Y[this.ptr + 13] != 0;
        }
      }, {
        key: "init",
        value: function init(t, r) {
          this.set_adjusted_ptr(0), this.set_type(t), this.set_destructor(r);
        }
      }, {
        key: "set_adjusted_ptr",
        value: function set_adjusted_ptr(t) {
          _[this.ptr + 16 >> 2] = t;
        }
      }, {
        key: "get_adjusted_ptr",
        value: function get_adjusted_ptr() {
          return _[this.ptr + 16 >> 2];
        }
      }, {
        key: "get_exception_ptr",
        value: function get_exception_ptr() {
          var t = _Ye(this.get_type());

          if (t) return _[this.excPtr >> 2];
          var r = this.get_adjusted_ptr();
          return r !== 0 ? r : this.excPtr;
        }
      }]);

      return Lt;
    }();

    var Dr = function Dr(e) {
      throw q || (q = e), q;
    },
        Yt = function Yt(e) {
      var t = q;
      if (!t) return _Ct(0), 0;
      var r = new Lt(t);
      r.set_adjusted_ptr(t);
      var n = r.get_type();
      if (!n) return _Ct(0), t;

      for (var a in e) {
        var o = e[a];
        if (o === 0 || o === n) break;
        var s = r.ptr + 16;
        if (_Le(o, n, s)) return _Ct(o), t;
      }

      return _Ct(n), t;
    },
        xr = function xr() {
      return Yt([]);
    },
        Or = function Or(e) {
      return Yt([e]);
    },
        Fr = function Fr(e, t) {
      return Yt([e, t]);
    },
        Mr = function Mr() {
      var e = Pt.pop();
      e || Tt("no exception to throw");
      var t = e.excPtr;
      throw e.get_rethrown() || (Pt.push(e), e.set_rethrown(!0), e.set_caught(!1), Et++), q = t, q;
    },
        Sr = function Sr(e, t, r) {
      var n = new Lt(e);
      throw n.init(t, r), q = e, Et++, q;
    },
        jr = function jr() {
      return Et;
    },
        At = {},
        zt = function zt(e) {
      for (; e.length;) {
        var t = e.pop(),
            r = e.pop();
        r(t);
      }
    };

    function mt(e) {
      return this.fromWireType(_[e >> 2]);
    }

    var st = {},
        rt = {},
        Dt = {},
        we,
        xt = function xt(e) {
      throw new we(e);
    },
        nt = function nt(e, t, r) {
      e.forEach(function (u) {
        Dt[u] = t;
      });

      function n(u) {
        var l = r(u);
        l.length !== e.length && xt("Mismatched type converter count");

        for (var h = 0; h < e.length; ++h) {
          N(e[h], l[h]);
        }
      }

      var a = new Array(t.length),
          o = [],
          s = 0;
      t.forEach(function (u, l) {
        rt.hasOwnProperty(u) ? a[l] = rt[u] : (o.push(u), st.hasOwnProperty(u) || (st[u] = []), st[u].push(function () {
          a[l] = rt[u], ++s, s === o.length && n(a);
        }));
      }), o.length === 0 && n(a);
    },
        Ir = function Ir(e) {
      var t = At[e];
      delete At[e];
      var r = t.rawConstructor,
          n = t.rawDestructor,
          a = t.fields,
          o = a.map(function (s) {
        return s.getterReturnType;
      }).concat(a.map(function (s) {
        return s.setterArgumentType;
      }));
      nt([e], o, function (s) {
        var u = {};
        return a.forEach(function (l, h) {
          var p = l.fieldName,
              g = s[h],
              y = l.getter,
              b = l.getterContext,
              O = s[h + a.length],
              k = l.setter,
              P = l.setterContext;
          u[p] = {
            read: function read(j) {
              return g.fromWireType(y(b, j));
            },
            write: function write(j, d) {
              var m = [];
              k(P, j, O.toWireType(m, d)), zt(m);
            }
          };
        }), [{
          name: t.name,
          fromWireType: function fromWireType(l) {
            var h = {};

            for (var p in u) {
              h[p] = u[p].read(l);
            }

            return n(l), h;
          },
          toWireType: function toWireType(l, h) {
            for (var p in u) {
              if (!(p in h)) throw new TypeError("Missing field: \"".concat(p, "\""));
            }

            var g = r();

            for (p in u) {
              u[p].write(g, h[p]);
            }

            return l !== null && l.push(n, g), g;
          },
          argPackAdvance: G,
          readValueFromPointer: mt,
          destructorFunction: n
        }];
      });
    },
        Wr = function Wr(e, t, r, n, a) {},
        Rr = function Rr() {
      for (var e = new Array(256), t = 0; t < 256; ++t) {
        e[t] = String.fromCharCode(t);
      }

      $e = e;
    },
        $e,
        I = function I(e) {
      for (var t = "", r = e; W[r];) {
        t += $e[W[r++]];
      }

      return t;
    },
        ut,
        C = function C(e) {
      throw new ut(e);
    };

    function kr(e, t) {
      var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      var n = t.name;

      if (e || C("type \"".concat(n, "\" must have a positive integer typeid pointer")), rt.hasOwnProperty(e)) {
        if (r.ignoreDuplicateRegistrations) return;
        C("Cannot register type '".concat(n, "' twice"));
      }

      if (rt[e] = t, delete Dt[e], st.hasOwnProperty(e)) {
        var a = st[e];
        delete st[e], a.forEach(function (o) {
          return o();
        });
      }
    }

    function N(e, t) {
      var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      if (!("argPackAdvance" in t)) throw new TypeError("registerType registeredInstance requires argPackAdvance");
      return kr(e, t, r);
    }

    var G = 8,
        Hr = function Hr(e, t, r, n) {
      t = I(t), N(e, {
        name: t,
        fromWireType: function fromWireType(a) {
          return !!a;
        },
        toWireType: function toWireType(a, o) {
          return o ? r : n;
        },
        argPackAdvance: G,
        readValueFromPointer: function readValueFromPointer(a) {
          return this.fromWireType(W[a]);
        },
        destructorFunction: null
      });
    },
        Br = function Br(e) {
      return {
        count: e.count,
        deleteScheduled: e.deleteScheduled,
        preservePointerOnDelete: e.preservePointerOnDelete,
        ptr: e.ptr,
        ptrType: e.ptrType,
        smartPtr: e.smartPtr,
        smartPtrType: e.smartPtrType
      };
    },
        Nt = function Nt(e) {
      function t(r) {
        return r.$$.ptrType.registeredClass.name;
      }

      C(t(e) + " instance already deleted");
    },
        Gt = !1,
        be = function be(e) {},
        Ur = function Ur(e) {
      e.smartPtr ? e.smartPtrType.rawDestructor(e.smartPtr) : e.ptrType.registeredClass.rawDestructor(e.ptr);
    },
        Ce = function Ce(e) {
      e.count.value -= 1;
      var t = e.count.value === 0;
      t && Ur(e);
    },
        _e = function _e(e, t, r) {
      if (t === r) return e;
      if (r.baseClass === void 0) return null;

      var n = _e(e, t, r.baseClass);

      return n === null ? null : r.downcast(n);
    },
        Te = {},
        Vr = function Vr() {
      return Object.keys(gt).length;
    },
        Lr = function Lr() {
      var e = [];

      for (var t in gt) {
        gt.hasOwnProperty(t) && e.push(gt[t]);
      }

      return e;
    },
        yt = [],
        Xt = function Xt() {
      for (; yt.length;) {
        var e = yt.pop();
        e.$$.deleteScheduled = !1, e.delete();
      }
    },
        vt,
        Yr = function Yr(e) {
      vt = e, yt.length && vt && vt(Xt);
    },
        zr = function zr() {
      c.getInheritedInstanceCount = Vr, c.getLiveInheritedInstances = Lr, c.flushPendingDeletes = Xt, c.setDelayFunction = Yr;
    },
        gt = {},
        Nr = function Nr(e, t) {
      for (t === void 0 && C("ptr should not be undefined"); e.baseClass;) {
        t = e.upcast(t), e = e.baseClass;
      }

      return t;
    },
        Gr = function Gr(e, t) {
      return t = Nr(e, t), gt[t];
    },
        Ot = function Ot(e, t) {
      (!t.ptrType || !t.ptr) && xt("makeClassHandle requires ptr and ptrType");
      var r = !!t.smartPtrType,
          n = !!t.smartPtr;
      return r !== n && xt("Both smartPtrType and smartPtr must be specified"), t.count = {
        value: 1
      }, _wt(Object.create(e, {
        $$: {
          value: t,
          writable: !0
        }
      }));
    };

    function Xr(e) {
      var t = this.getPointee(e);
      if (!t) return this.destructor(e), null;
      var r = Gr(this.registeredClass, t);

      if (r !== void 0) {
        if (r.$$.count.value === 0) return r.$$.ptr = t, r.$$.smartPtr = e, r.clone();
        var n = r.clone();
        return this.destructor(e), n;
      }

      function a() {
        return this.isSmartPointer ? Ot(this.registeredClass.instancePrototype, {
          ptrType: this.pointeeType,
          ptr: t,
          smartPtrType: this,
          smartPtr: e
        }) : Ot(this.registeredClass.instancePrototype, {
          ptrType: this,
          ptr: e
        });
      }

      var o = this.registeredClass.getActualType(t),
          s = Te[o];
      if (!s) return a.call(this);
      var u;
      this.isConst ? u = s.constPointerType : u = s.pointerType;

      var l = _e(t, this.registeredClass, u.registeredClass);

      return l === null ? a.call(this) : this.isSmartPointer ? Ot(u.registeredClass.instancePrototype, {
        ptrType: u,
        ptr: l,
        smartPtrType: this,
        smartPtr: e
      }) : Ot(u.registeredClass.instancePrototype, {
        ptrType: u,
        ptr: l
      });
    }

    var _wt = function wt(e) {
      return typeof FinalizationRegistry > "u" ? (_wt = function wt(t) {
        return t;
      }, e) : (Gt = new FinalizationRegistry(function (t) {
        Ce(t.$$);
      }), _wt = function wt(t) {
        var r = t.$$,
            n = !!r.smartPtr;

        if (n) {
          var a = {
            $$: r
          };
          Gt.register(t, a, t);
        }

        return t;
      }, be = function be(t) {
        return Gt.unregister(t);
      }, _wt(e));
    },
        qr = function qr() {
      Object.assign(Ft.prototype, {
        isAliasOf: function isAliasOf(e) {
          if (!(this instanceof Ft) || !(e instanceof Ft)) return !1;
          var t = this.$$.ptrType.registeredClass,
              r = this.$$.ptr;
          e.$$ = e.$$;

          for (var n = e.$$.ptrType.registeredClass, a = e.$$.ptr; t.baseClass;) {
            r = t.upcast(r), t = t.baseClass;
          }

          for (; n.baseClass;) {
            a = n.upcast(a), n = n.baseClass;
          }

          return t === n && r === a;
        },
        clone: function clone() {
          if (this.$$.ptr || Nt(this), this.$$.preservePointerOnDelete) return this.$$.count.value += 1, this;

          var e = _wt(Object.create(Object.getPrototypeOf(this), {
            $$: {
              value: Br(this.$$)
            }
          }));

          return e.$$.count.value += 1, e.$$.deleteScheduled = !1, e;
        },
        delete: function _delete() {
          this.$$.ptr || Nt(this), this.$$.deleteScheduled && !this.$$.preservePointerOnDelete && C("Object already scheduled for deletion"), be(this), Ce(this.$$), this.$$.preservePointerOnDelete || (this.$$.smartPtr = void 0, this.$$.ptr = void 0);
        },
        isDeleted: function isDeleted() {
          return !this.$$.ptr;
        },
        deleteLater: function deleteLater() {
          return this.$$.ptr || Nt(this), this.$$.deleteScheduled && !this.$$.preservePointerOnDelete && C("Object already scheduled for deletion"), yt.push(this), yt.length === 1 && vt && vt(Xt), this.$$.deleteScheduled = !0, this;
        }
      });
    };

    function Ft() {}

    var $t = function $t(e, t) {
      return Object.defineProperty(t, "name", {
        value: e
      });
    },
        Pe = function Pe(e, t, r) {
      if (e[t].overloadTable === void 0) {
        var n = e[t];
        e[t] = function () {
          for (var a = arguments.length, o = new Array(a), s = 0; s < a; s++) {
            o[s] = arguments[s];
          }

          return e[t].overloadTable.hasOwnProperty(o.length) || C("Function '".concat(r, "' called with an invalid number of arguments (").concat(o.length, ") - expects one of (").concat(e[t].overloadTable, ")!")), e[t].overloadTable[o.length].apply(this, o);
        }, e[t].overloadTable = [], e[t].overloadTable[n.argCount] = n;
      }
    },
        qt = function qt(e, t, r) {
      c.hasOwnProperty(e) ? ((r === void 0 || c[e].overloadTable !== void 0 && c[e].overloadTable[r] !== void 0) && C("Cannot register public name '".concat(e, "' twice")), Pe(c, e, e), c.hasOwnProperty(r) && C("Cannot register multiple overloads of a function with the same number of arguments (".concat(r, ")!")), c[e].overloadTable[r] = t) : (c[e] = t, r !== void 0 && (c[e].numArguments = r));
    },
        Qr = 48,
        Zr = 57,
        Jr = function Jr(e) {
      if (e === void 0) return "_unknown";
      e = e.replace(/[^a-zA-Z0-9_]/g, "$");
      var t = e.charCodeAt(0);
      return t >= Qr && t <= Zr ? "_".concat(e) : e;
    };

    function Kr(e, t, r, n, a, o, s, u) {
      this.name = e, this.constructor = t, this.instancePrototype = r, this.rawDestructor = n, this.baseClass = a, this.getActualType = o, this.upcast = s, this.downcast = u, this.pureVirtualFunctions = [];
    }

    var Qt = function Qt(e, t, r) {
      for (; t !== r;) {
        t.upcast || C("Expected null or instance of ".concat(r.name, ", got an instance of ").concat(t.name)), e = t.upcast(e), t = t.baseClass;
      }

      return e;
    };

    function tn(e, t) {
      if (t === null) return this.isReference && C("null is not a valid ".concat(this.name)), 0;
      t.$$ || C("Cannot pass \"".concat(re(t), "\" as a ").concat(this.name)), t.$$.ptr || C("Cannot pass deleted object as a pointer of type ".concat(this.name));
      var r = t.$$.ptrType.registeredClass,
          n = Qt(t.$$.ptr, r, this.registeredClass);
      return n;
    }

    function en(e, t) {
      var r;
      if (t === null) return this.isReference && C("null is not a valid ".concat(this.name)), this.isSmartPointer ? (r = this.rawConstructor(), e !== null && e.push(this.rawDestructor, r), r) : 0;
      (!t || !t.$$) && C("Cannot pass \"".concat(re(t), "\" as a ").concat(this.name)), t.$$.ptr || C("Cannot pass deleted object as a pointer of type ".concat(this.name)), !this.isConst && t.$$.ptrType.isConst && C("Cannot convert argument of type ".concat(t.$$.smartPtrType ? t.$$.smartPtrType.name : t.$$.ptrType.name, " to parameter type ").concat(this.name));
      var n = t.$$.ptrType.registeredClass;
      if (r = Qt(t.$$.ptr, n, this.registeredClass), this.isSmartPointer) switch (t.$$.smartPtr === void 0 && C("Passing raw pointer to smart pointer is illegal"), this.sharingPolicy) {
        case 0:
          t.$$.smartPtrType === this ? r = t.$$.smartPtr : C("Cannot convert argument of type ".concat(t.$$.smartPtrType ? t.$$.smartPtrType.name : t.$$.ptrType.name, " to parameter type ").concat(this.name));
          break;

        case 1:
          r = t.$$.smartPtr;
          break;

        case 2:
          if (t.$$.smartPtrType === this) r = t.$$.smartPtr;else {
            var a = t.clone();
            r = this.rawShare(r, Z.toHandle(function () {
              return a.delete();
            })), e !== null && e.push(this.rawDestructor, r);
          }
          break;

        default:
          C("Unsupporting sharing policy");
      }
      return r;
    }

    function rn(e, t) {
      if (t === null) return this.isReference && C("null is not a valid ".concat(this.name)), 0;
      t.$$ || C("Cannot pass \"".concat(re(t), "\" as a ").concat(this.name)), t.$$.ptr || C("Cannot pass deleted object as a pointer of type ".concat(this.name)), t.$$.ptrType.isConst && C("Cannot convert argument of type ".concat(t.$$.ptrType.name, " to parameter type ").concat(this.name));
      var r = t.$$.ptrType.registeredClass,
          n = Qt(t.$$.ptr, r, this.registeredClass);
      return n;
    }

    var nn = function nn() {
      Object.assign(Mt.prototype, {
        getPointee: function getPointee(e) {
          return this.rawGetPointee && (e = this.rawGetPointee(e)), e;
        },
        destructor: function destructor(e) {
          var t;
          (t = this.rawDestructor) === null || t === void 0 || t.call(this, e);
        },
        argPackAdvance: G,
        readValueFromPointer: mt,
        fromWireType: Xr
      });
    };

    function Mt(e, t, r, n, a, o, s, u, l, h, p) {
      this.name = e, this.registeredClass = t, this.isReference = r, this.isConst = n, this.isSmartPointer = a, this.pointeeType = o, this.sharingPolicy = s, this.rawGetPointee = u, this.rawConstructor = l, this.rawShare = h, this.rawDestructor = p, !a && t.baseClass === void 0 ? n ? (this.toWireType = tn, this.destructorFunction = null) : (this.toWireType = rn, this.destructorFunction = null) : this.toWireType = en;
    }

    var Ee = function Ee(e, t, r) {
      c.hasOwnProperty(e) || xt("Replacing nonexistant public symbol"), c[e].overloadTable !== void 0 && r !== void 0 ? c[e].overloadTable[r] = t : (c[e] = t, c[e].argCount = r);
    },
        an = function an(e, t, r) {
      var n = c["dynCall_" + e];
      return n.apply(void 0, [t].concat(_toConsumableArray(r)));
    },
        St = [],
        Ae,
        E = function E(e) {
      var t = St[e];
      return t || (e >= St.length && (St.length = e + 1), St[e] = t = Ae.get(e)), t;
    },
        on = function on(e, t) {
      var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
      if (e.includes("j")) return an(e, t, r);
      var n = E(t).apply(void 0, _toConsumableArray(r));
      return n;
    },
        sn = function sn(e, t) {
      return function () {
        for (var r = arguments.length, n = new Array(r), a = 0; a < r; a++) {
          n[a] = arguments[a];
        }

        return on(e, t, n);
      };
    },
        z = function z(e, t) {
      e = I(e);

      function r() {
        return e.includes("j") ? sn(e, t) : E(t);
      }

      var n = r();
      return typeof n != "function" && C("unknown function pointer with signature ".concat(e, ": ").concat(t)), n;
    },
        un = function un(e, t) {
      var r = $t(t, function (n) {
        this.name = t, this.message = n;
        var a = new Error(n).stack;
        a !== void 0 && (this.stack = this.toString() + "\n" + a.replace(/^Error(:[^\n]*)?\n/, ""));
      });
      return r.prototype = Object.create(e.prototype), r.prototype.constructor = r, r.prototype.toString = function () {
        return this.message === void 0 ? this.name : "".concat(this.name, ": ").concat(this.message);
      }, r;
    },
        De,
        xe = function xe(e) {
      var t = _Be(e),
          r = I(t);

      return J(t), r;
    },
        jt = function jt(e, t) {
      var r = [],
          n = {};

      function a(o) {
        if (!n[o] && !rt[o]) {
          if (Dt[o]) {
            Dt[o].forEach(a);
            return;
          }

          r.push(o), n[o] = !0;
        }
      }

      throw t.forEach(a), new De("".concat(e, ": ") + r.map(xe).join([", "]));
    },
        cn = function cn(e, t, r, n, a, o, s, u, l, h, p, g, y) {
      p = I(p), o = z(a, o), u && (u = z(s, u)), h && (h = z(l, h)), y = z(g, y);
      var b = Jr(p);
      qt(b, function () {
        jt("Cannot construct ".concat(p, " due to unbound types"), [n]);
      }), nt([e, t, r], n ? [n] : [], function (O) {
        O = O[0];
        var k, P;
        n ? (k = O.registeredClass, P = k.instancePrototype) : P = Ft.prototype;
        var j = $t(p, function () {
          if (Object.getPrototypeOf(this) !== d) throw new ut("Use 'new' to construct " + p);
          if (m.constructor_body === void 0) throw new ut(p + " has no accessible constructor");

          for (var Xe = arguments.length, kt = new Array(Xe), Ht = 0; Ht < Xe; Ht++) {
            kt[Ht] = arguments[Ht];
          }

          var qe = m.constructor_body[kt.length];
          if (qe === void 0) throw new ut("Tried to invoke ctor of ".concat(p, " with invalid number of parameters (").concat(kt.length, ") - expected (").concat(Object.keys(m.constructor_body).toString(), ") parameters instead!"));
          return qe.apply(this, kt);
        }),
            d = Object.create(P, {
          constructor: {
            value: j
          }
        });
        j.prototype = d;
        var m = new Kr(p, j, d, y, k, o, u, h);

        if (m.baseClass) {
          var F, S;
          (S = (F = m.baseClass).__derivedClasses) !== null && S !== void 0 || (F.__derivedClasses = []), m.baseClass.__derivedClasses.push(m);
        }

        var ct = new Mt(p, m, !0, !1, !1),
            Rt = new Mt(p + "*", m, !1, !1, !1),
            Ge = new Mt(p + " const*", m, !1, !0, !1);
        return Te[e] = {
          pointerType: Rt,
          constPointerType: Ge
        }, Ee(b, j), [ct, Rt, Ge];
      });
    },
        Zt = function Zt(e, t) {
      for (var r = [], n = 0; n < e; n++) {
        r.push(_[t + n * 4 >> 2]);
      }

      return r;
    };

    function ln(e) {
      for (var t = 1; t < e.length; ++t) {
        if (e[t] !== null && e[t].destructorFunction === void 0) return !0;
      }

      return !1;
    }

    function Jt(e, t, r, n, a, o) {
      var s = t.length;
      s < 2 && C("argTypes array size mismatch! Must at least get return value and 'this' types!");

      var u = t[1] !== null && r !== null,
          l = ln(t),
          h = t[0].name !== "void",
          p = s - 2,
          g = new Array(p),
          y = [],
          b = [],
          O = function O() {
        arguments.length !== p && C("function ".concat(e, " called with ").concat(arguments.length, " arguments, expected ").concat(p)), b.length = 0;
        var k;
        y.length = u ? 2 : 1, y[0] = a, u && (k = t[1].toWireType(b, this), y[1] = k);

        for (var P = 0; P < p; ++P) {
          g[P] = t[P + 2].toWireType(b, P < 0 || arguments.length <= P ? void 0 : arguments[P]), y.push(g[P]);
        }

        var j = n.apply(void 0, y);

        function d(m) {
          if (l) zt(b);else for (var F = u ? 1 : 2; F < t.length; F++) {
            var S = F === 1 ? k : g[F - 2];
            t[F].destructorFunction !== null && t[F].destructorFunction(S);
          }
          if (h) return t[0].fromWireType(m);
        }

        return d(j);
      };

      return $t(e, O);
    }

    var dn = function dn(e, t, r, n, a, o) {
      var s = Zt(t, r);
      a = z(n, a), nt([], [e], function (u) {
        u = u[0];
        var l = "constructor ".concat(u.name);
        if (u.registeredClass.constructor_body === void 0 && (u.registeredClass.constructor_body = []), u.registeredClass.constructor_body[t - 1] !== void 0) throw new ut("Cannot register multiple constructors with identical number of parameters (".concat(t - 1, ") for class '").concat(u.name, "'! Overload resolution is currently only performed using the parameter count, not actual type info!"));
        return u.registeredClass.constructor_body[t - 1] = function () {
          jt("Cannot construct ".concat(u.name, " due to unbound types"), s);
        }, nt([], s, function (h) {
          return h.splice(1, 0, null), u.registeredClass.constructor_body[t - 1] = Jt(l, h, null, a, o), [];
        }), [];
      });
    },
        Oe = function Oe(e) {
      e = e.trim();
      var t = e.indexOf("(");
      return t !== -1 ? e.substr(0, t) : e;
    },
        hn = function hn(e, t, r, n, a, o, s, u, l) {
      var h = Zt(r, n);
      t = I(t), t = Oe(t), o = z(a, o), nt([], [e], function (p) {
        p = p[0];
        var g = "".concat(p.name, ".").concat(t);
        t.startsWith("@@") && (t = Symbol[t.substring(2)]), u && p.registeredClass.pureVirtualFunctions.push(t);

        function y() {
          jt("Cannot call ".concat(g, " due to unbound types"), h);
        }

        var b = p.registeredClass.instancePrototype,
            O = b[t];
        return O === void 0 || O.overloadTable === void 0 && O.className !== p.name && O.argCount === r - 2 ? (y.argCount = r - 2, y.className = p.name, b[t] = y) : (Pe(b, t, g), b[t].overloadTable[r - 2] = y), nt([], h, function (k) {
          var P = Jt(g, k, p, o, s);
          return b[t].overloadTable === void 0 ? (P.argCount = r - 2, b[t] = P) : b[t].overloadTable[r - 2] = P, [];
        }), [];
      });
    },
        Kt = [],
        Q = [],
        te = function te(e) {
      e > 9 && --Q[e + 1] === 0 && (Q[e] = void 0, Kt.push(e));
    },
        fn = function fn() {
      return Q.length / 2 - 5 - Kt.length;
    },
        pn = function pn() {
      Q.push(0, 1, void 0, 1, null, 1, !0, 1, !1, 1), c.count_emval_handles = fn;
    },
        Z = {
      toValue: function toValue(e) {
        return e || C("Cannot use deleted val. handle = " + e), Q[e];
      },
      toHandle: function toHandle(e) {
        switch (e) {
          case void 0:
            return 2;

          case null:
            return 4;

          case !0:
            return 6;

          case !1:
            return 8;

          default:
            {
              var t = Kt.pop() || Q.length;
              return Q[t] = e, Q[t + 1] = 1, t;
            }
        }
      }
    },
        mn = {
      name: "emscripten::val",
      fromWireType: function fromWireType(e) {
        var t = Z.toValue(e);
        return te(e), t;
      },
      toWireType: function toWireType(e, t) {
        return Z.toHandle(t);
      },
      argPackAdvance: G,
      readValueFromPointer: mt,
      destructorFunction: null
    },
        Fe = function Fe(e) {
      return N(e, mn);
    },
        yn = function yn(e, t, r) {
      switch (t) {
        case 1:
          return r ? function (n) {
            return this.fromWireType(Y[n]);
          } : function (n) {
            return this.fromWireType(W[n]);
          };

        case 2:
          return r ? function (n) {
            return this.fromWireType(ot[n >> 1]);
          } : function (n) {
            return this.fromWireType(ft[n >> 1]);
          };

        case 4:
          return r ? function (n) {
            return this.fromWireType(R[n >> 2]);
          } : function (n) {
            return this.fromWireType(_[n >> 2]);
          };

        default:
          throw new TypeError("invalid integer width (".concat(t, "): ").concat(e));
      }
    },
        vn = function vn(e, t, r, n) {
      t = I(t);

      function a() {}

      a.values = {}, N(e, {
        name: t,
        constructor: a,
        fromWireType: function fromWireType(o) {
          return this.constructor.values[o];
        },
        toWireType: function toWireType(o, s) {
          return s.value;
        },
        argPackAdvance: G,
        readValueFromPointer: yn(t, r, n),
        destructorFunction: null
      }), qt(t, a);
    },
        ee = function ee(e, t) {
      var r = rt[e];
      return r === void 0 && C("".concat(t, " has unknown type ").concat(xe(e))), r;
    },
        gn = function gn(e, t, r) {
      var n = ee(e, "enum");
      t = I(t);
      var a = n.constructor,
          o = Object.create(n.constructor.prototype, {
        value: {
          value: r
        },
        constructor: {
          value: $t("".concat(n.name, "_").concat(t), function () {})
        }
      });
      a.values[r] = o, a[t] = o;
    },
        re = function re(e) {
      if (e === null) return "null";
      var t = typeof e;
      return t === "object" || t === "array" || t === "function" ? e.toString() : "" + e;
    },
        wn = function wn(e, t) {
      switch (t) {
        case 4:
          return function (r) {
            return this.fromWireType(le[r >> 2]);
          };

        case 8:
          return function (r) {
            return this.fromWireType(de[r >> 3]);
          };

        default:
          throw new TypeError("invalid float width (".concat(t, "): ").concat(e));
      }
    },
        $n = function $n(e, t, r) {
      t = I(t), N(e, {
        name: t,
        fromWireType: function fromWireType(n) {
          return n;
        },
        toWireType: function toWireType(n, a) {
          return a;
        },
        argPackAdvance: G,
        readValueFromPointer: wn(t, r),
        destructorFunction: null
      });
    },
        bn = function bn(e, t, r, n, a, o, s) {
      var u = Zt(t, r);
      e = I(e), e = Oe(e), a = z(n, a), qt(e, function () {
        jt("Cannot call ".concat(e, " due to unbound types"), u);
      }, t - 1), nt([], u, function (l) {
        var h = [l[0], null].concat(l.slice(1));
        return Ee(e, Jt(e, h, null, a, o), t - 1), [];
      });
    },
        Cn = function Cn(e, t, r) {
      switch (t) {
        case 1:
          return r ? function (n) {
            return Y[n];
          } : function (n) {
            return W[n];
          };

        case 2:
          return r ? function (n) {
            return ot[n >> 1];
          } : function (n) {
            return ft[n >> 1];
          };

        case 4:
          return r ? function (n) {
            return R[n >> 2];
          } : function (n) {
            return _[n >> 2];
          };

        default:
          throw new TypeError("invalid integer width (".concat(t, "): ").concat(e));
      }
    },
        _n = function _n(e, t, r, n, a) {
      t = I(t);

      var o = function o(p) {
        return p;
      };

      if (n === 0) {
        var s = 32 - 8 * r;

        o = function o(p) {
          return p << s >>> s;
        };
      }

      var u = t.includes("unsigned"),
          l = function l(p, g) {},
          h;

      u ? h = function h(p, g) {
        return l(g, this.name), g >>> 0;
      } : h = function h(p, g) {
        return l(g, this.name), g;
      }, N(e, {
        name: t,
        fromWireType: o,
        toWireType: h,
        argPackAdvance: G,
        readValueFromPointer: Cn(t, r, n !== 0),
        destructorFunction: null
      });
    },
        Tn = function Tn(e, t, r) {
      var n = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array],
          a = n[t];

      function o(s) {
        var u = _[s >> 2],
            l = _[s + 4 >> 2];
        return new a(Y.buffer, l, u);
      }

      r = I(r), N(e, {
        name: r,
        fromWireType: o,
        argPackAdvance: G,
        readValueFromPointer: o
      }, {
        ignoreDuplicateRegistrations: !0
      });
    },
        Pn = function Pn(e, t) {
      Fe(e);
    },
        Me = function Me(e, t, r, n) {
      if (!(n > 0)) return 0;

      for (var a = r, o = r + n - 1, s = 0; s < e.length; ++s) {
        var u = e.charCodeAt(s);

        if (u >= 55296 && u <= 57343) {
          var l = e.charCodeAt(++s);
          u = 65536 + ((u & 1023) << 10) | l & 1023;
        }

        if (u <= 127) {
          if (r >= o) break;
          t[r++] = u;
        } else if (u <= 2047) {
          if (r + 1 >= o) break;
          t[r++] = 192 | u >> 6, t[r++] = 128 | u & 63;
        } else if (u <= 65535) {
          if (r + 2 >= o) break;
          t[r++] = 224 | u >> 12, t[r++] = 128 | u >> 6 & 63, t[r++] = 128 | u & 63;
        } else {
          if (r + 3 >= o) break;
          t[r++] = 240 | u >> 18, t[r++] = 128 | u >> 12 & 63, t[r++] = 128 | u >> 6 & 63, t[r++] = 128 | u & 63;
        }
      }

      return t[r] = 0, r - a;
    },
        En = function En(e, t, r) {
      return Me(e, W, t, r);
    },
        Se = function Se(e) {
      for (var t = 0, r = 0; r < e.length; ++r) {
        var n = e.charCodeAt(r);
        n <= 127 ? t++ : n <= 2047 ? t += 2 : n >= 55296 && n <= 57343 ? (t += 4, ++r) : t += 3;
      }

      return t;
    },
        je = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0,
        Ie = function Ie(e, t, r) {
      for (var n = t + r, a = t; e[a] && !(a >= n);) {
        ++a;
      }

      if (a - t > 16 && e.buffer && je) return je.decode(e.subarray(t, a));

      for (var o = ""; t < a;) {
        var s = e[t++];

        if (!(s & 128)) {
          o += String.fromCharCode(s);
          continue;
        }

        var u = e[t++] & 63;

        if ((s & 224) == 192) {
          o += String.fromCharCode((s & 31) << 6 | u);
          continue;
        }

        var l = e[t++] & 63;
        if ((s & 240) == 224 ? s = (s & 15) << 12 | u << 6 | l : s = (s & 7) << 18 | u << 12 | l << 6 | e[t++] & 63, s < 65536) o += String.fromCharCode(s);else {
          var h = s - 65536;
          o += String.fromCharCode(55296 | h >> 10, 56320 | h & 1023);
        }
      }

      return o;
    },
        ne = function ne(e, t) {
      return e ? Ie(W, e, t) : "";
    },
        An = function An(e, t) {
      t = I(t);
      var r = t === "std::string";
      N(e, {
        name: t,
        fromWireType: function fromWireType(n) {
          var a = _[n >> 2],
              o = n + 4,
              s;
          if (r) for (var u = o, l = 0; l <= a; ++l) {
            var h = o + l;

            if (l == a || W[h] == 0) {
              var p = h - u,
                  g = ne(u, p);
              s === void 0 ? s = g : (s += "\0", s += g), u = h + 1;
            }
          } else {
            for (var y = new Array(a), l = 0; l < a; ++l) {
              y[l] = String.fromCharCode(W[o + l]);
            }

            s = y.join("");
          }
          return J(n), s;
        },
        toWireType: function toWireType(n, a) {
          a instanceof ArrayBuffer && (a = new Uint8Array(a));
          var o,
              s = typeof a == "string";
          s || a instanceof Uint8Array || a instanceof Uint8ClampedArray || a instanceof Int8Array || C("Cannot pass non-string to std::string"), r && s ? o = Se(a) : o = a.length;
          var u = ie(4 + o + 1),
              l = u + 4;
          if (_[u >> 2] = o, r && s) En(a, l, o + 1);else if (s) for (var h = 0; h < o; ++h) {
            var p = a.charCodeAt(h);
            p > 255 && (J(l), C("String has UTF-16 code units that do not fit in 8 bits")), W[l + h] = p;
          } else for (var h = 0; h < o; ++h) {
            W[l + h] = a[h];
          }
          return n !== null && n.push(J, u), u;
        },
        argPackAdvance: G,
        readValueFromPointer: mt,
        destructorFunction: function destructorFunction(n) {
          J(n);
        }
      });
    },
        We = typeof TextDecoder < "u" ? new TextDecoder("utf-16le") : void 0,
        Dn = function Dn(e, t) {
      for (var r = e, n = r >> 1, a = n + t / 2; !(n >= a) && ft[n];) {
        ++n;
      }

      if (r = n << 1, r - e > 32 && We) return We.decode(W.subarray(e, r));

      for (var o = "", s = 0; !(s >= t / 2); ++s) {
        var u = ot[e + s * 2 >> 1];
        if (u == 0) break;
        o += String.fromCharCode(u);
      }

      return o;
    },
        xn = function xn(e, t, r) {
      var n;
      if ((n = r) !== null && n !== void 0 || (r = 2147483647), r < 2) return 0;
      r -= 2;

      for (var a = t, o = r < e.length * 2 ? r / 2 : e.length, s = 0; s < o; ++s) {
        var u = e.charCodeAt(s);
        ot[t >> 1] = u, t += 2;
      }

      return ot[t >> 1] = 0, t - a;
    },
        On = function On(e) {
      return e.length * 2;
    },
        Fn = function Fn(e, t) {
      for (var r = 0, n = ""; !(r >= t / 4);) {
        var a = R[e + r * 4 >> 2];
        if (a == 0) break;

        if (++r, a >= 65536) {
          var o = a - 65536;
          n += String.fromCharCode(55296 | o >> 10, 56320 | o & 1023);
        } else n += String.fromCharCode(a);
      }

      return n;
    },
        Mn = function Mn(e, t, r) {
      var n;
      if ((n = r) !== null && n !== void 0 || (r = 2147483647), r < 4) return 0;

      for (var a = t, o = a + r - 4, s = 0; s < e.length; ++s) {
        var u = e.charCodeAt(s);

        if (u >= 55296 && u <= 57343) {
          var l = e.charCodeAt(++s);
          u = 65536 + ((u & 1023) << 10) | l & 1023;
        }

        if (R[t >> 2] = u, t += 4, t + 4 > o) break;
      }

      return R[t >> 2] = 0, t - a;
    },
        Sn = function Sn(e) {
      for (var t = 0, r = 0; r < e.length; ++r) {
        var n = e.charCodeAt(r);
        n >= 55296 && n <= 57343 && ++r, t += 4;
      }

      return t;
    },
        jn = function jn(e, t, r) {
      r = I(r);
      var n, a, o, s;
      t === 2 ? (n = Dn, a = xn, s = On, o = function o(u) {
        return ft[u >> 1];
      }) : t === 4 && (n = Fn, a = Mn, s = Sn, o = function o(u) {
        return _[u >> 2];
      }), N(e, {
        name: r,
        fromWireType: function fromWireType(u) {
          for (var l = _[u >> 2], h, p = u + 4, g = 0; g <= l; ++g) {
            var y = u + 4 + g * t;

            if (g == l || o(y) == 0) {
              var b = y - p,
                  O = n(p, b);
              h === void 0 ? h = O : (h += "\0", h += O), p = y + t;
            }
          }

          return J(u), h;
        },
        toWireType: function toWireType(u, l) {
          typeof l != "string" && C("Cannot pass non-string to C++ string type ".concat(r));
          var h = s(l),
              p = ie(4 + h + t);
          return _[p >> 2] = h / t, a(l, p + 4, h + t), u !== null && u.push(J, p), p;
        },
        argPackAdvance: G,
        readValueFromPointer: mt,
        destructorFunction: function destructorFunction(u) {
          J(u);
        }
      });
    },
        In = function In(e, t, r, n, a, o) {
      At[e] = {
        name: I(t),
        rawConstructor: z(r, n),
        rawDestructor: z(a, o),
        fields: []
      };
    },
        Wn = function Wn(e, t, r, n, a, o, s, u, l, h) {
      At[e].fields.push({
        fieldName: I(t),
        getterReturnType: r,
        getter: z(n, a),
        getterContext: o,
        setterArgumentType: s,
        setter: z(u, l),
        setterContext: h
      });
    },
        Rn = function Rn(e, t) {
      t = I(t), N(e, {
        isVoid: !0,
        name: t,
        argPackAdvance: 0,
        fromWireType: function fromWireType() {},
        toWireType: function toWireType(r, n) {}
      });
    },
        ae = [],
        kn = function kn(e, t, r, n) {
      return e = ae[e], t = Z.toValue(t), e(null, t, r, n);
    },
        Hn = {},
        Bn = function Bn(e) {
      var t = Hn[e];
      return t === void 0 ? I(e) : t;
    },
        Re = function Re() {
      if (typeof globalThis == "object") return globalThis;

      function e(t) {
        t.$$$embind_global$$$ = t;
        var r = typeof $$$embind_global$$$ == "object" && t.$$$embind_global$$$ == t;
        return r || delete t.$$$embind_global$$$, r;
      }

      if (typeof $$$embind_global$$$ == "object" || (typeof global == "object" && e(global) ? $$$embind_global$$$ = global : typeof self == "object" && e(self) && ($$$embind_global$$$ = self), typeof $$$embind_global$$$ == "object")) return $$$embind_global$$$;
      throw Error("unable to get global object.");
    },
        Un = function Un(e) {
      return e === 0 ? Z.toHandle(Re()) : (e = Bn(e), Z.toHandle(Re()[e]));
    },
        Vn = function Vn(e) {
      var t = ae.length;
      return ae.push(e), t;
    },
        Ln = function Ln(e, t) {
      for (var r = new Array(e), n = 0; n < e; ++n) {
        r[n] = ee(_[t + n * 4 >> 2], "parameter " + n);
      }

      return r;
    },
        Yn = Reflect.construct,
        zn = function zn(e, t, r) {
      var n = [],
          a = e.toWireType(n, r);
      return n.length && (_[t >> 2] = Z.toHandle(n)), a;
    },
        Nn = function Nn(e, t, r) {
      var n = Ln(e, t),
          a = n.shift();
      e--;

      var o = new Array(e),
          s = function s(l, h, p, g) {
        for (var y = 0, b = 0; b < e; ++b) {
          o[b] = n[b].readValueFromPointer(g + y), y += n[b].argPackAdvance;
        }

        var O = r === 1 ? Yn(h, o) : h.apply(l, o);
        return zn(a, p, O);
      },
          u = "methodCaller<(".concat(n.map(function (l) {
        return l.name;
      }).join(", "), ") => ").concat(a.name, ">");

      return Vn($t(u, s));
    },
        Gn = function Gn(e) {
      e > 9 && (Q[e + 1] += 1);
    },
        Xn = function Xn(e) {
      var t = Z.toValue(e);
      zt(t), te(e);
    },
        qn = function qn(e, t) {
      e = ee(e, "_emval_take_value");
      var r = e.readValueFromPointer(t);
      return Z.toHandle(r);
    },
        Qn = function Qn() {
      Tt("");
    },
        Zn = function Zn(e, t, r) {
      return W.copyWithin(e, t, t + r);
    },
        Jn = function Jn() {
      return 2147483648;
    },
        Kn = function Kn(e) {
      var t = at.buffer,
          r = (e - t.byteLength + 65535) / 65536;

      try {
        return at.grow(r), he(), 1;
      } catch (_unused) {}
    },
        ta = function ta(e) {
      var t = W.length;
      e >>>= 0;
      var r = Jn();
      if (e > r) return !1;

      for (var n = function n(l, h) {
        return l + (h - l % h) % h;
      }, a = 1; a <= 4; a *= 2) {
        var o = t * (1 + 0.2 / a);
        o = Math.min(o, e + 100663296);
        var s = Math.min(r, n(Math.max(e, o), 65536)),
            u = Kn(s);
        if (u) return !0;
      }

      return !1;
    },
        oe = {},
        ea = function ea() {
      return B || "./this.program";
    },
        bt = function bt() {
      if (!bt.strings) {
        var e = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8",
            t = {
          USER: "web_user",
          LOGNAME: "web_user",
          PATH: "/",
          PWD: "/",
          HOME: "/home/web_user",
          LANG: e,
          _: ea()
        };

        for (var r in oe) {
          oe[r] === void 0 ? delete t[r] : t[r] = oe[r];
        }

        var n = [];

        for (var r in t) {
          n.push("".concat(r, "=").concat(t[r]));
        }

        bt.strings = n;
      }

      return bt.strings;
    },
        ra = function ra(e, t) {
      for (var r = 0; r < e.length; ++r) {
        Y[t++] = e.charCodeAt(r);
      }

      Y[t] = 0;
    },
        na = function na(e, t) {
      var r = 0;
      return bt().forEach(function (n, a) {
        var o = t + r;
        _[e + a * 4 >> 2] = o, ra(n, o), r += n.length + 1;
      }), 0;
    },
        aa = function aa(e, t) {
      var r = bt();
      _[e >> 2] = r.length;
      var n = 0;
      return r.forEach(function (a) {
        return n += a.length + 1;
      }), _[t >> 2] = n, 0;
    },
        oa = function oa(e) {
      return 52;
    };

    function ia(e, t, r, n, a) {
      return 70;
    }

    var sa = [null, [], []],
        ua = function ua(e, t) {
      var r = sa[e];
      t === 0 || t === 10 ? ((e === 1 ? ht : X)(Ie(r, 0)), r.length = 0) : r.push(t);
    },
        ca = function ca(e, t, r, n) {
      for (var a = 0, o = 0; o < r; o++) {
        var s = _[t >> 2],
            u = _[t + 4 >> 2];
        t += 8;

        for (var l = 0; l < u; l++) {
          ua(e, W[s + l]);
        }

        a += u;
      }

      return _[n >> 2] = a, 0;
    },
        la = function la(e) {
      return e;
    },
        It = function It(e) {
      return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
    },
        da = function da(e, t) {
      for (var r = 0, n = 0; n <= t; r += e[n++]) {
        ;
      }

      return r;
    },
        ke = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
        He = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
        ha = function ha(e, t) {
      for (var r = new Date(e.getTime()); t > 0;) {
        var n = It(r.getFullYear()),
            a = r.getMonth(),
            o = (n ? ke : He)[a];
        if (t > o - r.getDate()) t -= o - r.getDate() + 1, r.setDate(1), a < 11 ? r.setMonth(a + 1) : (r.setMonth(0), r.setFullYear(r.getFullYear() + 1));else return r.setDate(r.getDate() + t), r;
      }

      return r;
    };

    function fa(e, t, r) {
      var n = r > 0 ? r : Se(e) + 1,
          a = new Array(n),
          o = Me(e, a, 0, a.length);
      return t && (a.length = o), a;
    }

    var pa = function pa(e, t) {
      Y.set(e, t);
    },
        ma = function ma(e, t, r, n) {
      var a = _[n + 40 >> 2],
          o = {
        tm_sec: R[n >> 2],
        tm_min: R[n + 4 >> 2],
        tm_hour: R[n + 8 >> 2],
        tm_mday: R[n + 12 >> 2],
        tm_mon: R[n + 16 >> 2],
        tm_year: R[n + 20 >> 2],
        tm_wday: R[n + 24 >> 2],
        tm_yday: R[n + 28 >> 2],
        tm_isdst: R[n + 32 >> 2],
        tm_gmtoff: R[n + 36 >> 2],
        tm_zone: a ? ne(a) : ""
      },
          s = ne(r),
          u = {
        "%c": "%a %b %d %H:%M:%S %Y",
        "%D": "%m/%d/%y",
        "%F": "%Y-%m-%d",
        "%h": "%b",
        "%r": "%I:%M:%S %p",
        "%R": "%H:%M",
        "%T": "%H:%M:%S",
        "%x": "%m/%d/%y",
        "%X": "%H:%M:%S",
        "%Ec": "%c",
        "%EC": "%C",
        "%Ex": "%m/%d/%y",
        "%EX": "%H:%M:%S",
        "%Ey": "%y",
        "%EY": "%Y",
        "%Od": "%d",
        "%Oe": "%e",
        "%OH": "%H",
        "%OI": "%I",
        "%Om": "%m",
        "%OM": "%M",
        "%OS": "%S",
        "%Ou": "%u",
        "%OU": "%U",
        "%OV": "%V",
        "%Ow": "%w",
        "%OW": "%W",
        "%Oy": "%y"
      };

      for (var l in u) {
        s = s.replace(new RegExp(l, "g"), u[l]);
      }

      var h = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          p = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

      function g(d, m, F) {
        for (var S = typeof d == "number" ? d.toString() : d || ""; S.length < m;) {
          S = F[0] + S;
        }

        return S;
      }

      function y(d, m) {
        return g(d, m, "0");
      }

      function b(d, m) {
        function F(ct) {
          return ct < 0 ? -1 : ct > 0 ? 1 : 0;
        }

        var S;
        return (S = F(d.getFullYear() - m.getFullYear())) === 0 && (S = F(d.getMonth() - m.getMonth())) === 0 && (S = F(d.getDate() - m.getDate())), S;
      }

      function O(d) {
        switch (d.getDay()) {
          case 0:
            return new Date(d.getFullYear() - 1, 11, 29);

          case 1:
            return d;

          case 2:
            return new Date(d.getFullYear(), 0, 3);

          case 3:
            return new Date(d.getFullYear(), 0, 2);

          case 4:
            return new Date(d.getFullYear(), 0, 1);

          case 5:
            return new Date(d.getFullYear() - 1, 11, 31);

          case 6:
            return new Date(d.getFullYear() - 1, 11, 30);
        }
      }

      function k(d) {
        var m = ha(new Date(d.tm_year + 1900, 0, 1), d.tm_yday),
            F = new Date(m.getFullYear(), 0, 4),
            S = new Date(m.getFullYear() + 1, 0, 4),
            ct = O(F),
            Rt = O(S);
        return b(ct, m) <= 0 ? b(Rt, m) <= 0 ? m.getFullYear() + 1 : m.getFullYear() : m.getFullYear() - 1;
      }

      var P = {
        "%a": function a(d) {
          return h[d.tm_wday].substring(0, 3);
        },
        "%A": function A(d) {
          return h[d.tm_wday];
        },
        "%b": function b(d) {
          return p[d.tm_mon].substring(0, 3);
        },
        "%B": function B(d) {
          return p[d.tm_mon];
        },
        "%C": function C(d) {
          var m = d.tm_year + 1900;
          return y(m / 100 | 0, 2);
        },
        "%d": function d(_d) {
          return y(_d.tm_mday, 2);
        },
        "%e": function e(d) {
          return g(d.tm_mday, 2, " ");
        },
        "%g": function g(d) {
          return k(d).toString().substring(2);
        },
        "%G": k,
        "%H": function H(d) {
          return y(d.tm_hour, 2);
        },
        "%I": function I(d) {
          var m = d.tm_hour;
          return m == 0 ? m = 12 : m > 12 && (m -= 12), y(m, 2);
        },
        "%j": function j(d) {
          return y(d.tm_mday + da(It(d.tm_year + 1900) ? ke : He, d.tm_mon - 1), 3);
        },
        "%m": function m(d) {
          return y(d.tm_mon + 1, 2);
        },
        "%M": function M(d) {
          return y(d.tm_min, 2);
        },
        "%n": function n() {
          return "\n";
        },
        "%p": function p(d) {
          return d.tm_hour >= 0 && d.tm_hour < 12 ? "AM" : "PM";
        },
        "%S": function S(d) {
          return y(d.tm_sec, 2);
        },
        "%t": function t() {
          return "	";
        },
        "%u": function u(d) {
          return d.tm_wday || 7;
        },
        "%U": function U(d) {
          var m = d.tm_yday + 7 - d.tm_wday;
          return y(Math.floor(m / 7), 2);
        },
        "%V": function V(d) {
          var m = Math.floor((d.tm_yday + 7 - (d.tm_wday + 6) % 7) / 7);

          if ((d.tm_wday + 371 - d.tm_yday - 2) % 7 <= 2 && m++, m) {
            if (m == 53) {
              var F = (d.tm_wday + 371 - d.tm_yday) % 7;
              F != 4 && (F != 3 || !It(d.tm_year)) && (m = 1);
            }
          } else {
            m = 52;
            var S = (d.tm_wday + 7 - d.tm_yday - 1) % 7;
            (S == 4 || S == 5 && It(d.tm_year % 400 - 1)) && m++;
          }

          return y(m, 2);
        },
        "%w": function w(d) {
          return d.tm_wday;
        },
        "%W": function W(d) {
          var m = d.tm_yday + 7 - (d.tm_wday + 6) % 7;
          return y(Math.floor(m / 7), 2);
        },
        "%y": function y(d) {
          return (d.tm_year + 1900).toString().substring(2);
        },
        "%Y": function Y(d) {
          return d.tm_year + 1900;
        },
        "%z": function z(d) {
          var m = d.tm_gmtoff,
              F = m >= 0;
          return m = Math.abs(m) / 60, m = m / 60 * 100 + m % 60, (F ? "+" : "-") + ("0000" + m).slice(-4);
        },
        "%Z": function Z(d) {
          return d.tm_zone;
        },
        "%%": function _() {
          return "%";
        }
      };
      s = s.replace(/%%/g, "\0\0");

      for (var l in P) {
        s.includes(l) && (s = s.replace(new RegExp(l, "g"), P[l](o)));
      }

      s = s.replace(/\0\0/g, "%");
      var j = fa(s, !1);
      return j.length > t ? 0 : (pa(j, e), j.length - 1);
    },
        ya = function ya(e, t, r, n, a) {
      return ma(e, t, r, n);
    };

    we = c.InternalError = /*#__PURE__*/function (_Error) {
      _inherits(_class, _Error);

      function _class(e) {
        var _this;

        _classCallCheck(this, _class);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, e)), _this.name = "InternalError";
        return _this;
      }

      return _class;
    }(_wrapNativeSuper(Error)), Rr(), ut = c.BindingError = /*#__PURE__*/function (_Error2) {
      _inherits(_class2, _Error2);

      function _class2(e) {
        var _this2;

        _classCallCheck(this, _class2);

        _this2 = _possibleConstructorReturn(this, _getPrototypeOf(_class2).call(this, e)), _this2.name = "BindingError";
        return _this2;
      }

      return _class2;
    }(_wrapNativeSuper(Error)), qr(), zr(), nn(), De = c.UnboundTypeError = un(Error, "UnboundTypeError"), pn();

    var va = {
      s: Er,
      u: Ar,
      b: xr,
      g: Or,
      q: Fr,
      K: Mr,
      f: Sr,
      Y: jr,
      d: Dr,
      ha: Ir,
      U: Wr,
      ba: Hr,
      fa: cn,
      ea: dn,
      w: hn,
      aa: Fe,
      x: vn,
      h: gn,
      O: $n,
      P: bn,
      t: _n,
      o: Tn,
      ga: Pn,
      N: An,
      C: jn,
      A: In,
      ia: Wn,
      ca: Rn,
      E: kn,
      ka: te,
      la: Un,
      M: Nn,
      Q: Gn,
      R: Xn,
      da: qn,
      B: Qn,
      $: Zn,
      Z: ta,
      W: na,
      X: aa,
      _: oa,
      T: ia,
      L: ca,
      F: Sa,
      D: Ca,
      G: Ma,
      m: ja,
      a: ga,
      e: Ta,
      p: ba,
      k: Fa,
      I: xa,
      v: Aa,
      H: Oa,
      z: Wa,
      S: ka,
      l: Pa,
      j: _a,
      c: $a,
      n: wa,
      J: Da,
      r: Ia,
      i: Ea,
      y: Ra,
      ja: la,
      V: ya
    },
        A = Pr(),
        J = c._free = function (e) {
      return (J = c._free = A.oa)(e);
    },
        ie = c._malloc = function (e) {
      return (ie = c._malloc = A.pa)(e);
    },
        _Be = function Be(e) {
      return (_Be = A.ra)(e);
    },
        _T = function T(e, t) {
      return (_T = A.sa)(e, t);
    },
        _Ct = function Ct(e) {
      return (_Ct = A.ta)(e);
    },
        _D = function D() {
      return (_D = A.ua)();
    },
        _x5 = function x(e) {
      return (_x5 = A.va)(e);
    },
        _Ue = function Ue(e) {
      return (_Ue = A.wa)(e);
    },
        _Ve = function Ve(e) {
      return (_Ve = A.xa)(e);
    },
        _Le = function Le(e, t, r) {
      return (_Le = A.ya)(e, t, r);
    },
        _Ye = function Ye(e) {
      return (_Ye = A.za)(e);
    };

    c.dynCall_viijii = function (e, t, r, n, a, o, s) {
      return (c.dynCall_viijii = A.Aa)(e, t, r, n, a, o, s);
    }, c.dynCall_jiji = function (e, t, r, n, a) {
      return (c.dynCall_jiji = A.Ba)(e, t, r, n, a);
    };

    var ze = c.dynCall_jiiii = function (e, t, r, n, a) {
      return (ze = c.dynCall_jiiii = A.Ca)(e, t, r, n, a);
    };

    c.dynCall_iiiiij = function (e, t, r, n, a, o, s) {
      return (c.dynCall_iiiiij = A.Da)(e, t, r, n, a, o, s);
    }, c.dynCall_iiiiijj = function (e, t, r, n, a, o, s, u, l) {
      return (c.dynCall_iiiiijj = A.Ea)(e, t, r, n, a, o, s, u, l);
    }, c.dynCall_iiiiiijj = function (e, t, r, n, a, o, s, u, l, h) {
      return (c.dynCall_iiiiiijj = A.Fa)(e, t, r, n, a, o, s, u, l, h);
    };

    function ga(e, t) {
      var r = _D();

      try {
        return E(e)(t);
      } catch (n) {
        if (_x5(r), n !== n + 0) throw n;

        _T(1, 0);
      }
    }

    function wa(e, t, r, n) {
      var a = _D();

      try {
        E(e)(t, r, n);
      } catch (o) {
        if (_x5(a), o !== o + 0) throw o;

        _T(1, 0);
      }
    }

    function $a(e, t, r) {
      var n = _D();

      try {
        E(e)(t, r);
      } catch (a) {
        if (_x5(n), a !== a + 0) throw a;

        _T(1, 0);
      }
    }

    function ba(e, t, r, n) {
      var a = _D();

      try {
        return E(e)(t, r, n);
      } catch (o) {
        if (_x5(a), o !== o + 0) throw o;

        _T(1, 0);
      }
    }

    function Ca(e, t, r, n, a) {
      var o = _D();

      try {
        return E(e)(t, r, n, a);
      } catch (s) {
        if (_x5(o), s !== s + 0) throw s;

        _T(1, 0);
      }
    }

    function _a(e, t) {
      var r = _D();

      try {
        E(e)(t);
      } catch (n) {
        if (_x5(r), n !== n + 0) throw n;

        _T(1, 0);
      }
    }

    function Ta(e, t, r) {
      var n = _D();

      try {
        return E(e)(t, r);
      } catch (a) {
        if (_x5(n), a !== a + 0) throw a;

        _T(1, 0);
      }
    }

    function Pa(e) {
      var t = _D();

      try {
        E(e)();
      } catch (r) {
        if (_x5(t), r !== r + 0) throw r;

        _T(1, 0);
      }
    }

    function Ea(e, t, r, n, a, o, s, u, l, h, p) {
      var g = _D();

      try {
        E(e)(t, r, n, a, o, s, u, l, h, p);
      } catch (y) {
        if (_x5(g), y !== y + 0) throw y;

        _T(1, 0);
      }
    }

    function Aa(e, t, r, n, a, o, s) {
      var u = _D();

      try {
        return E(e)(t, r, n, a, o, s);
      } catch (l) {
        if (_x5(u), l !== l + 0) throw l;

        _T(1, 0);
      }
    }

    function Da(e, t, r, n, a) {
      var o = _D();

      try {
        E(e)(t, r, n, a);
      } catch (s) {
        if (_x5(o), s !== s + 0) throw s;

        _T(1, 0);
      }
    }

    function xa(e, t, r, n, a, o) {
      var s = _D();

      try {
        return E(e)(t, r, n, a, o);
      } catch (u) {
        if (_x5(s), u !== u + 0) throw u;

        _T(1, 0);
      }
    }

    function Oa(e, t, r, n, a, o, s, u) {
      var l = _D();

      try {
        return E(e)(t, r, n, a, o, s, u);
      } catch (h) {
        if (_x5(l), h !== h + 0) throw h;

        _T(1, 0);
      }
    }

    function Fa(e, t, r, n, a) {
      var o = _D();

      try {
        return E(e)(t, r, n, a);
      } catch (s) {
        if (_x5(o), s !== s + 0) throw s;

        _T(1, 0);
      }
    }

    function Ma(e, t, r, n) {
      var a = _D();

      try {
        return E(e)(t, r, n);
      } catch (o) {
        if (_x5(a), o !== o + 0) throw o;

        _T(1, 0);
      }
    }

    function Sa(e, t, r, n) {
      var a = _D();

      try {
        return E(e)(t, r, n);
      } catch (o) {
        if (_x5(a), o !== o + 0) throw o;

        _T(1, 0);
      }
    }

    function ja(e) {
      var t = _D();

      try {
        return E(e)();
      } catch (r) {
        if (_x5(t), r !== r + 0) throw r;

        _T(1, 0);
      }
    }

    function Ia(e, t, r, n, a, o, s, u) {
      var l = _D();

      try {
        E(e)(t, r, n, a, o, s, u);
      } catch (h) {
        if (_x5(l), h !== h + 0) throw h;

        _T(1, 0);
      }
    }

    function Wa(e, t, r, n, a, o, s, u, l, h, p, g) {
      var y = _D();

      try {
        return E(e)(t, r, n, a, o, s, u, l, h, p, g);
      } catch (b) {
        if (_x5(y), b !== b + 0) throw b;

        _T(1, 0);
      }
    }

    function Ra(e, t, r, n, a, o, s, u, l, h, p, g, y, b, O, k) {
      var P = _D();

      try {
        E(e)(t, r, n, a, o, s, u, l, h, p, g, y, b, O, k);
      } catch (j) {
        if (_x5(P), j !== j + 0) throw j;

        _T(1, 0);
      }
    }

    function ka(e, t, r, n, a) {
      var o = _D();

      try {
        return ze(e, t, r, n, a);
      } catch (s) {
        if (_x5(o), s !== s + 0) throw s;

        _T(1, 0);
      }
    }

    var Wt;

    pt = function e() {
      Wt || Ne(), Wt || (pt = e);
    };

    function Ne() {
      if (et > 0 || (pr(), et > 0)) return;

      function e() {
        Wt || (Wt = !0, c.calledRun = !0, !_t && (mr(), w(c), c.onRuntimeInitialized && c.onRuntimeInitialized(), yr()));
      }

      c.setStatus ? (c.setStatus("Running..."), setTimeout(function () {
        setTimeout(function () {
          c.setStatus("");
        }, 1), e();
      }, 1)) : e();
    }

    if (c.preInit) for (typeof c.preInit == "function" && (c.preInit = [c.preInit]); c.preInit.length > 0;) {
      c.preInit.pop()();
    }
    return Ne(), f.ready;
  };
}();

function Za(i) {
  return ce(Ut, i);
}

function mo(i) {
  return Xa(Ut, i);
}

function Ja(_x6, _x7) {
  return _Ja.apply(this, arguments);
}

function _Ja() {
  _Ja = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(i, f) {
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", qa(Ut, i, f));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _Ja.apply(this, arguments);
}

function Ka(_x8, _x9) {
  return _Ka.apply(this, arguments);
}

function _Ka() {
  _Ka = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(i, f) {
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", Qa(Ut, i, f));

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _Ka.apply(this, arguments);
}

var ar = [["aztec", "Aztec"], ["code_128", "Code128"], ["code_39", "Code39"], ["code_93", "Code93"], ["codabar", "Codabar"], ["databar", "DataBar"], ["databar_expanded", "DataBarExpanded"], ["data_matrix", "DataMatrix"], ["dx_film_edge", "DXFilmEdge"], ["ean_13", "EAN-13"], ["ean_8", "EAN-8"], ["itf", "ITF"], ["maxi_code", "MaxiCode"], ["micro_qr_code", "MicroQRCode"], ["pdf417", "PDF417"], ["qr_code", "QRCode"], ["rm_qr_code", "rMQRCode"], ["upc_a", "UPC-A"], ["upc_e", "UPC-E"], ["linear_codes", "Linear-Codes"], ["matrix_codes", "Matrix-Codes"]],
    to = [].concat(ar, [["unknown"]]).map(function (i) {
  return i[0];
}),
    Bt = new Map(ar);

function eo(i) {
  var _iterator = _createForOfIteratorHelper(Bt),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
          f = _step$value[0],
          c = _step$value[1];

      if (i === c) return f;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return "unknown";
}

function ro(i) {
  if (or(i)) return {
    width: i.naturalWidth,
    height: i.naturalHeight
  };
  if (ir(i)) return {
    width: i.width.baseVal.value,
    height: i.height.baseVal.value
  };
  if (sr(i)) return {
    width: i.videoWidth,
    height: i.videoHeight
  };
  if (cr(i)) return {
    width: i.width,
    height: i.height
  };
  if (dr(i)) return {
    width: i.displayWidth,
    height: i.displayHeight
  };
  if (ur(i)) return {
    width: i.width,
    height: i.height
  };
  if (lr(i)) return {
    width: i.width,
    height: i.height
  };
  throw new TypeError("The provided value is not of type '(Blob or HTMLCanvasElement or HTMLImageElement or HTMLVideoElement or ImageBitmap or ImageData or OffscreenCanvas or SVGImageElement or VideoFrame)'.");
}

function or(i) {
  try {
    return i instanceof HTMLImageElement;
  } catch (_unused2) {
    return !1;
  }
}

function ir(i) {
  try {
    return i instanceof SVGImageElement;
  } catch (_unused3) {
    return !1;
  }
}

function sr(i) {
  try {
    return i instanceof HTMLVideoElement;
  } catch (_unused4) {
    return !1;
  }
}

function ur(i) {
  try {
    return i instanceof HTMLCanvasElement;
  } catch (_unused5) {
    return !1;
  }
}

function cr(i) {
  try {
    return i instanceof ImageBitmap;
  } catch (_unused6) {
    return !1;
  }
}

function lr(i) {
  try {
    return i instanceof OffscreenCanvas;
  } catch (_unused7) {
    return !1;
  }
}

function dr(i) {
  try {
    return i instanceof VideoFrame;
  } catch (_unused8) {
    return !1;
  }
}

function hr(i) {
  try {
    return i instanceof Blob;
  } catch (_unused9) {
    return !1;
  }
}

function no(i) {
  try {
    return i instanceof ImageData;
  } catch (_unused10) {
    return !1;
  }
}

function ao(i, f) {
  try {
    var c = new OffscreenCanvas(i, f);
    if (c.getContext("2d") instanceof OffscreenCanvasRenderingContext2D) return c;
    throw void 0;
  } catch (_unused11) {
    var _c = document.createElement("canvas");

    return _c.width = i, _c.height = f, _c;
  }
}

function fr(_x10) {
  return _fr.apply(this, arguments);
}

function _fr() {
  _fr = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(i) {
    var _ro, f, c, v;

    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.t0 = or(i);

            if (!_context7.t0) {
              _context7.next = 5;
              break;
            }

            _context7.next = 4;
            return uo(i);

          case 4:
            _context7.t0 = !_context7.sent;

          case 5:
            if (!_context7.t0) {
              _context7.next = 7;
              break;
            }

            throw new DOMException("Failed to load or decode HTMLImageElement.", "InvalidStateError");

          case 7:
            _context7.t1 = ir(i);

            if (!_context7.t1) {
              _context7.next = 12;
              break;
            }

            _context7.next = 11;
            return co(i);

          case 11:
            _context7.t1 = !_context7.sent;

          case 12:
            if (!_context7.t1) {
              _context7.next = 14;
              break;
            }

            throw new DOMException("Failed to load or decode SVGImageElement.", "InvalidStateError");

          case 14:
            if (!(dr(i) && lo(i))) {
              _context7.next = 16;
              break;
            }

            throw new DOMException("VideoFrame is closed.", "InvalidStateError");

          case 16:
            if (!(sr(i) && (i.readyState === 0 || i.readyState === 1))) {
              _context7.next = 18;
              break;
            }

            throw new DOMException("Invalid element or state.", "InvalidStateError");

          case 18:
            if (!(cr(i) && fo(i))) {
              _context7.next = 20;
              break;
            }

            throw new DOMException("The image source is detached.", "InvalidStateError");

          case 20:
            _ro = ro(i), f = _ro.width, c = _ro.height;

            if (!(f === 0 || c === 0)) {
              _context7.next = 23;
              break;
            }

            return _context7.abrupt("return", null);

          case 23:
            v = ao(f, c).getContext("2d");
            v.drawImage(i, 0, 0);
            _context7.prev = 25;
            return _context7.abrupt("return", v.getImageData(0, 0, f, c));

          case 29:
            _context7.prev = 29;
            _context7.t2 = _context7["catch"](25);
            throw new DOMException("Source would taint origin.", "SecurityError");

          case 32:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[25, 29]]);
  }));
  return _fr.apply(this, arguments);
}

function oo(_x11) {
  return _oo.apply(this, arguments);
}

function _oo() {
  _oo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(i) {
    var f, w;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;

            if (!globalThis.createImageBitmap) {
              _context8.next = 7;
              break;
            }

            _context8.next = 4;
            return createImageBitmap(i);

          case 4:
            f = _context8.sent;
            _context8.next = 21;
            break;

          case 7:
            if (!globalThis.Image) {
              _context8.next = 20;
              break;
            }

            f = new Image();
            w = "";
            _context8.prev = 10;
            w = URL.createObjectURL(i);
            f.src = w;
            _context8.next = 15;
            return f.decode();

          case 15:
            _context8.prev = 15;
            URL.revokeObjectURL(w);
            return _context8.finish(15);

          case 18:
            _context8.next = 21;
            break;

          case 20:
            return _context8.abrupt("return", i);

          case 21:
            _context8.next = 26;
            break;

          case 23:
            _context8.prev = 23;
            _context8.t0 = _context8["catch"](0);
            throw new DOMException("Failed to load or decode Blob.", "InvalidStateError");

          case 26:
            _context8.next = 28;
            return fr(f);

          case 28:
            return _context8.abrupt("return", _context8.sent);

          case 29:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 23], [10,, 15, 18]]);
  }));
  return _oo.apply(this, arguments);
}

function io(i) {
  var f = i.width,
      c = i.height;
  if (f === 0 || c === 0) return null;
  var w = i.getContext("2d");

  try {
    return w.getImageData(0, 0, f, c);
  } catch (_unused12) {
    throw new DOMException("Source would taint origin.", "SecurityError");
  }
}

function so(_x12) {
  return _so.apply(this, arguments);
}

function _so() {
  _so = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(i) {
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (!hr(i)) {
              _context9.next = 4;
              break;
            }

            _context9.next = 3;
            return oo(i);

          case 3:
            return _context9.abrupt("return", _context9.sent);

          case 4:
            if (!no(i)) {
              _context9.next = 8;
              break;
            }

            if (!ho(i)) {
              _context9.next = 7;
              break;
            }

            throw new DOMException("The image data has been detached.", "InvalidStateError");

          case 7:
            return _context9.abrupt("return", i);

          case 8:
            if (!(ur(i) || lr(i))) {
              _context9.next = 12;
              break;
            }

            _context9.t0 = io(i);
            _context9.next = 15;
            break;

          case 12:
            _context9.next = 14;
            return fr(i);

          case 14:
            _context9.t0 = _context9.sent;

          case 15:
            return _context9.abrupt("return", _context9.t0);

          case 16:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _so.apply(this, arguments);
}

function uo(_x13) {
  return _uo.apply(this, arguments);
}

function _uo() {
  _uo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(i) {
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            _context10.next = 3;
            return i.decode();

          case 3:
            return _context10.abrupt("return", !0);

          case 6:
            _context10.prev = 6;
            _context10.t0 = _context10["catch"](0);
            return _context10.abrupt("return", !1);

          case 9:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[0, 6]]);
  }));
  return _uo.apply(this, arguments);
}

function co(_x14) {
  return _co.apply(this, arguments);
}

function _co() {
  _co = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(i) {
    var f;
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.prev = 0;
            _context11.next = 3;
            return (f = i.decode) == null ? void 0 : f.call(i);

          case 3:
            return _context11.abrupt("return", !0);

          case 6:
            _context11.prev = 6;
            _context11.t0 = _context11["catch"](0);
            return _context11.abrupt("return", !1);

          case 9:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[0, 6]]);
  }));
  return _co.apply(this, arguments);
}

function lo(i) {
  return i.format === null;
}

function ho(i) {
  return i.data.buffer.byteLength === 0;
}

function fo(i) {
  return i.width === 0 && i.height === 0;
}

function er(i, f) {
  return i instanceof DOMException ? new DOMException("".concat(f, ": ").concat(i.message), i.name) : i instanceof Error ? new i.constructor("".concat(f, ": ").concat(i.message)) : new Error("".concat(f, ": ").concat(i));
}

var lt;

var yo = /*#__PURE__*/function (_EventTarget) {
  _inherits(yo, _EventTarget);

  function yo() {
    var _this3;

    var c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, yo);

    var w;
    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(yo).call(this));
    Ze(_assertThisInitialized(_assertThisInitialized(_this3)), lt, void 0);

    try {
      var v = (w = c == null ? void 0 : c.formats) == null ? void 0 : w.filter(function ($) {
        return $ !== "unknown";
      });
      if ((v == null ? void 0 : v.length) === 0) throw new TypeError("Hint option provided, but is empty.");

      var _iterator2 = _createForOfIteratorHelper(v != null ? v : []),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var $ = _step2.value;
          if (!Bt.has($)) throw new TypeError("Failed to read the 'formats' property from 'BarcodeDetectorOptions': The provided value '".concat($, "' is not a valid enum value of type BarcodeFormat."));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      Je(_assertThisInitialized(_assertThisInitialized(_this3)), lt, v != null ? v : []), Za().then(function ($) {
        _this3.dispatchEvent(new CustomEvent("load", {
          detail: $
        }));
      }).catch(function ($) {
        _this3.dispatchEvent(new CustomEvent("error", {
          detail: $
        }));
      });
    } catch (v) {
      throw er(v, "Failed to construct 'BarcodeDetector'");
    }

    return _this3;
  }

  _createClass(yo, [{
    key: "detect",
    value: function () {
      var _detect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(c) {
        var w, v;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return so(c);

              case 3:
                w = _context.sent;

                if (!(w === null)) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", []);

              case 6:
                _context.prev = 6;

                if (!hr(w)) {
                  _context.next = 13;
                  break;
                }

                _context.next = 10;
                return Ja(w, {
                  tryHarder: !0,
                  formats: se(this, lt).map(function ($) {
                    return Bt.get($);
                  })
                });

              case 10:
                v = _context.sent;
                _context.next = 16;
                break;

              case 13:
                _context.next = 15;
                return Ka(w, {
                  tryHarder: !0,
                  formats: se(this, lt).map(function ($) {
                    return Bt.get($);
                  })
                });

              case 15:
                v = _context.sent;

              case 16:
                _context.next = 21;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](6);
                throw console.error(_context.t0), new DOMException("Barcode detection service unavailable.", "NotSupportedError");

              case 21:
                return _context.abrupt("return", v.map(function ($) {
                  var _$$position = $.position,
                      _$$position$topLeft = _$$position.topLeft,
                      B = _$$position$topLeft.x,
                      U = _$$position$topLeft.y,
                      _$$position$topRight = _$$position.topRight,
                      V = _$$position$topRight.x,
                      H = _$$position$topRight.y,
                      _$$position$bottomLef = _$$position.bottomLeft,
                      M = _$$position$bottomLef.x,
                      K = _$$position$bottomLef.y,
                      _$$position$bottomRig = _$$position.bottomRight,
                      L = _$$position$bottomRig.x,
                      ht = _$$position$bottomRig.y,
                      X = Math.min(B, V, M, L),
                      tt = Math.min(U, H, K, ht),
                      at = Math.max(B, V, M, L),
                      _t = Math.max(U, H, K, ht);

                  return {
                    boundingBox: new DOMRectReadOnly(X, tt, at - X, _t - tt),
                    rawValue: $.text,
                    format: eo($.format),
                    cornerPoints: [{
                      x: B,
                      y: U
                    }, {
                      x: V,
                      y: H
                    }, {
                      x: L,
                      y: ht
                    }, {
                      x: M,
                      y: K
                    }]
                  };
                }));

              case 24:
                _context.prev = 24;
                _context.t1 = _context["catch"](0);
                throw er(_context.t1, "Failed to execute 'detect' on 'BarcodeDetector'");

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 24], [6, 18]]);
      }));

      function detect(_x15) {
        return _detect.apply(this, arguments);
      }

      return detect;
    }()
  }], [{
    key: "getSupportedFormats",
    value: function () {
      var _getSupportedFormats = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", to.filter(function (c) {
                  return c !== "unknown";
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getSupportedFormats() {
        return _getSupportedFormats.apply(this, arguments);
      }

      return getSupportedFormats;
    }()
  }]);

  return yo;
}(_wrapNativeSuper(EventTarget));

lt = new WeakMap();
export { yo as BarcodeDetector, mo as setZXingModuleOverrides };